import React, { FC, ReactNode } from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { MsalAccessTokenProvider } from "./MsalAccessTokenProvider";
import {
  AccessTokenContextProvider,
  User,
} from "shared-ts-utils-authentication";
import { AccountInfoContextProvider } from "./AccountInfoContextProvider";
import { InteractionType } from "@azure/msal-browser";

const noScopes: Array<string> = [];

export interface MsalTemplatesProps {
  tenantId?: string;
  clientId: string;
  scopes?: Array<string>;
  method: InteractionType;
  authenticated: (user: User) => ReactNode;
  unauthenticated: () => ReactNode;
}

export const MsalContentProtector: FC<MsalTemplatesProps> = (props) => {
  return (
    <>
      <AuthenticatedTemplate>
        <MsalAccessTokenProvider
          clientId={props.clientId}
          method={props.method}
          scopes={props.scopes ?? noScopes}
        >
          {(token) => {
            return (
              <AccessTokenContextProvider token={token}>
                <AccountInfoContextProvider>
                  {(user) => props.authenticated(user)}
                </AccountInfoContextProvider>
              </AccessTokenContextProvider>
            );
          }}
        </MsalAccessTokenProvider>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        {props.unauthenticated()}
      </UnauthenticatedTemplate>
    </>
  );
};
